export default __webpack_public_path__ + "static/media/KFOmCnqEu92Fr1Mu4WxKKTU1Kvnz.13acea62.woff2";